import { Route, Switch } from "react-router";

import DataConnectorsListPage from "./pages/DataConnectorsListPage";
import DataConnectorDetailsPage from "./pages/DataConnectorDetailsPage";

export default function DataConnectorsPage() {
  return (
    <div>
      <Switch>
        <Route
          path="/destinations/data-connectors"
          exact
          component={DataConnectorsListPage}
        />
        <Route
          path="/destinations/data-connectors/:id"
          exact
          component={DataConnectorDetailsPage}
        />
      </Switch>
    </div>
  );
}
